<template>
  <div class="order-list">
    <!-- 顶部导航栏 -->
    <van-nav-bar title="订单列表" left-arrow @click-left="onClickLeft" fixed />

    <!-- 查询条件 -->
    <div class="search-form">
      <van-field
        v-model="searchForm.idCard"
        label="身份证号码"
        placeholder="请输入身份证后六位"
        clearable
      />
      <van-field
        v-model="searchForm.phone"
        label="手机号码"
        placeholder="请输入手机号码"
        clearable
      />
      <div class="search-buttons">
        <van-button color="#1989fa" size="normal" @click="handleSearch"
          >查询</van-button
        >
        <van-button plain color="#1989fa" size="normal" @click="handleReset"
          >重置</van-button
        >
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="order-content">
      <!-- 订单卡片 -->
      <div
        class="order-item"
        v-for="(order, index) in mockOrders"
        :key="order.id || index"
      >
        <div class="order-row">
          <span class="label">订单号：</span>
          <span class="value">{{ order.orderNo || '-' }}</span>
        </div>
        <div class="order-row">
          <span class="label">号码：</span>
          <span class="value">{{ formatMobile(order) || '-' }}</span>
        </div>
        <div class="order-row">
          <span class="label">下单时间：</span>
          <span class="value">{{ formatTime(order.simOrderTime) }}</span>
        </div>
        <!-- <div class="order-status">
          <van-tag :type="getStatusType(order.status)">
            {{ getStatusText(order.status) }}
          </van-tag>
        </div> -->
        <div class="order-actions">
          <van-button
            plain
            type="info"
            size="small"
            @click="viewOrderDetail(order)"
          >
            订单详情
          </van-button>
        </div>
      </div>
    </div>

    <!-- 订单详情弹窗 -->
    <van-dialog
      v-model="showDetailPopup"
      title="订单详情"
      :show-confirm-button="true"
      confirmButtonColor="#1989fa"
    >
      <div class="detail-content" v-if="currentOrder">
        <!-- 订单编号：按需求隐藏（广州电信订单页不展示），保留以备恢复 -->
        <!-- <div class="detail-item">
          <span class="detail-label">订单编号：</span>
          <span class="detail-value">{{ (currentOrder.myself && currentOrder.myself.code) || '-' }}</span>
        </div> -->
        <div class="detail-item">
          <span class="detail-label">号码：</span>
          <span class="detail-value">{{ (currentOrder.master && currentOrder.master.phoneAccess) || '-' }}</span>
        </div>
        <!-- 产品名称：按需求隐藏（广州电信订单页不展示），保留以备恢复 -->
        <!-- <div class="detail-item">
          <span class="detail-label">产品名称：</span>
          <span class="detail-value">{{ (currentOrder.myself && currentOrder.myself.orderProductName) || '-' }}</span>
        </div> -->
        <div class="detail-item">
          <span class="detail-label">业务类型：</span>
          <span class="detail-value">{{ (currentOrder.myself && currentOrder.myself.orderBusinessType) || '-' }}</span>
        </div>
        <!-- 代理商：按需求隐藏（广州电信订单页不展示），保留以备恢复 -->
        <!-- <div class="detail-item">
          <span class="detail-label">代理商：</span>
          <span class="detail-value">{{ (currentOrder.myself && currentOrder.myself.agentSubject) || '-' }}</span>
        </div> -->
        <div class="detail-item">
          <span class="detail-label">下单时间：</span>
          <span class="detail-value">{{ formatTime(currentOrder.myself && currentOrder.myself.createAt) }}</span>
        </div>

        <div class="detail-item">
          <span class="detail-label">收件地址：</span>
          <span class="detail-value">{{ getFullAddress(currentOrder.address) }}</span>
        </div>
        <!-- 配送类型：按需求隐藏（广州电信订单页不展示），保留以备恢复 -->
        <!-- <div class="detail-item">
          <span class="detail-label">配送类型：</span>
          <span class="detail-value">{{ (currentOrder.detail && currentOrder.detail.distributeType) || '-' }}</span>
        </div> -->
        <div class="detail-item">
          <span class="detail-label">物流公司：</span>
          <span class="detail-value">{{ (currentOrder.detail && currentOrder.detail.logisticsCompany) || '-' }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">订单状态：</span>
          <span class="detail-value">{{ (currentOrder.status && currentOrder.status.statusName) || '-' }}</span>
        </div>
        <div class="detail-item" v-if="currentOrder.status && currentOrder.status.setAt">
          <span class="detail-label">状态时间：</span>
          <span class="detail-value">{{ formatTime(currentOrder.status.setAt) }}</span>
        </div>

        <!-- 状态备注信息 -->
        <template v-if="getStatusRemarkData()">
          <div class="detail-item status-remark-item" v-for="(value, key) in getStatusRemarkData()" :key="key">
            <span class="detail-label">{{ key }}：</span>
            <span class="detail-value">{{ value }}</span>
          </div>
        </template>

        <!-- 快递单号 -->
        <template v-if="currentOrder.orderWaybillValues && currentOrder.orderWaybillValues.length > 0">
          <div class="detail-item">
            <span class="detail-label">快递单号：</span>
            <span class="detail-value">{{ currentOrder.orderWaybillValues[0].waybillCode }}</span>
          </div>
        </template>

        <!-- 快递记录 -->
        <template v-if="hasWaybillDetails()">
          <div class="detail-item route-details">
            <span class="detail-label">快递记录：</span>
            <div class="detail-value route-list">
              <div class="route-item" v-for="(route, index) in currentOrder.orderWaybillValues[0].waybillCodeEntity.waybill.attrList" :key="index">
                <div class="route-time">{{ route.operatingTime }}</div>
                <div class="route-code">{{ route.code }}</div>
                <div class="route-remark">{{ route.remark }}</div>
              </div>
            </div>
          </div>
        </template>
        
        <!-- 作废原因显示 -->
        <template v-if="isOrderInvalid()">
          <div class="detail-item" v-for="(reason, index) in currentOrder.orderInvalidValues" :key="index">
            <span class="detail-label">作废原因：</span>
            <span class="detail-value">{{ reason.invalidReason || '-' }}<br v-if="reason.invalidReasonDetail">{{ reason.invalidReasonDetail }}</span> 
          </div>
        </template>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { http } from "@/api/http";
// import { getSpiId } from "@/utils/spi";
import { NavBar, Tag, Field, Button, Dialog } from "vant";

// 注册组件
Vue.use(NavBar).use(Tag).use(Field).use(Button).use(Dialog);

export default {
  name: "OrderList",

  data() {
    return {
      // 查询条件
      searchForm: {
        idCard: "",
        phone: "",
        // idCard: "01133X",
        // phone: "18617358020",
      },
      orderStatus: [
        { label: "待付款", value: 0 },
        { label: "待收货", value: 1 },
        { label: "已完成", value: 2 },
      ],
      // 模拟订单数据
      mockOrders: [],
      // 弹窗控制
      showDetailPopup: false,
      // 当前查看的订单
      currentOrder: null,
      spiId: "guangzhou-telecom-01",
    };
  },
  created() {
    // spiId 不通过 URL 传递：优先内存变量（骑手页等跳转时设置），回落到 App.vue 写入的 localStorage.gysCode
    // this.spiId = getSpiId();
    console.log("OrderList spiId =>", this.spiId);
  },
  mounted() {
    // 防止页面自动滚动到底部
    window.scrollTo(0, 0);
  },
  methods: {
    // 返回上一页
    onClickLeft() {
      this.$router.back();
    },

    // 获取订单状态类型
    getStatusType(status) {
      const types = ["warning", "success", "default"];
      return types[status] || "default";
    },

    // 获取订单状态文本
    getStatusText(status) {
      return (
        this.orderStatus.find((item) => item.value === status)?.label ||
        "未知状态"
      );
    },

    // 格式化时间
    formatTime(time) {
      if (!time) return "-";
      const date = new Date(time);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 处理查询
    async handleSearch() {
      // "01133X"
      // "18617358020"
      // guangzhou-telecom-01
      // console.log("查询条件：", this.searchForm);
      if (!this.searchForm.idCard) {
        this.$toast("请输入身份证后六位");
        return;
      }
      if (!this.searchForm.phone) {
        this.$toast("请输入手机号码");
        return;
      }
      let params = {
        idCard6: this.searchForm.idCard,
        mobile: this.searchForm.phone,
        spiId: this.spiId,
      };
      console.log("查询条件 params =>", params);
      const { code, result, message } = await http("queryOrder", params);
      if (code == 200) {
        console.log("查询列表 result =>", result);
        this.mockOrders = result;
      } else {
        this.mockOrders = [];
        this.$toast(message);
      }
      // 这里添加查询逻辑
    },

    // 处理重置
    handleReset() {
      this.searchForm.idCard = "";
      this.searchForm.phone = "";
    },

    // 查看订单详情
    async viewOrderDetail(order) {
      let params = {
        orderId: order.id,
        spiId: this.spiId,
      };
      console.log("查询订单详情 params =>", params);
      const { code, result, message } = await http(
        "queryOrderByOrderId",
        params
      );
      if (code == 200 && result.data && result.data.q.length > 0) {
        console.log("订单详情 result =>", result);
        this.currentOrder = result.data.q[0];
        this.showDetailPopup = true;
      } else {
        this.currentOrder = {};
        this.$toast(message);
      }
    },

    // 格式化开卡号码：选了随机号码（comboMobile=random）展示「随机」
    formatMobile(order) {
      if (!order) return "";
      const mobile = order.comboMobile || order.mobile || "";
      if (String(mobile).toLowerCase() === "random") {
        return "随机";
      }
      return mobile;
    },

    // 获取手机号码
    getMobileNumber(order) {
      if (!order || !order.mobilePhones || !order.mobilePhones.length) {
        return "-";
      }
      return order.mobilePhones[0].mobileNumber || "-";
    },

    // 拼接完整地址
    getFullAddress(address) {
      if (!address) return "-";
      const { province, city, district, detailAddr } = address;
      const parts = [province, city, district, detailAddr].filter(Boolean);
      return parts.length > 0 ? parts.join("") : "-";
    },

    // 检查是否有快递记录
    hasWaybillDetails() {
      if (!this.currentOrder || !this.currentOrder.orderWaybillValues || this.currentOrder.orderWaybillValues.length === 0) {
        return false;
      }
      const waybill = this.currentOrder.orderWaybillValues[0];
      return waybill.waybillCodeEntity && 
             waybill.waybillCodeEntity.waybill && 
             waybill.waybillCodeEntity.waybill.attrList && 
             waybill.waybillCodeEntity.waybill.attrList.length > 0;
    },

    // 检查订单是否作废
    isOrderInvalid() {
      if (!this.currentOrder) return false;
      const statusName = this.currentOrder.status && this.currentOrder.status.statusName;
      return statusName === '作废' && 
             this.currentOrder.orderInvalidValues && 
             this.currentOrder.orderInvalidValues.length > 0;
    },

    // 解析状态备注信息
    getStatusRemarkData() {
      if (!this.currentOrder || !this.currentOrder.status || !this.currentOrder.status.statusRemark) {
        return null;
      }
      
      const statusRemark = this.currentOrder.status.statusRemark;
      
      // 尝试解析 JSON
      try {
        const parsed = JSON.parse(statusRemark);
        // 确保解析结果是对象
        if (typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)) {
          return parsed;
        }
      } catch (e) {
        // JSON 解析失败，忽略
        console.log('statusRemark 不是有效的 JSON 格式');
      }
      
      return null;
    }
  },
};
</script>

<style lang="less" scoped>
.order-list {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-top: 46px;

  .search-form {
    background-color: #fff;
    padding: 10px;
    margin-bottom: 10px;

    .search-buttons {
      display: flex;
      justify-content: center;
      padding: 16px;
      gap: 15px;

      .van-button {
        width: 120px;
        height: 40px;
        font-size: 16px;
      }
    }
  }

  .order-content {
    padding: 10px;
  }

  .order-item {
    background-color: #fff;
    padding: 16px;
    margin-bottom: 10px;
    border-radius: 8px;
    position: relative;

    .order-row {
      margin-bottom: 8px;
      font-size: 14px;
      display: flex;
      align-items: center;

      &:last-child {
        margin-bottom: 0;
      }

      .label {
        color: #666;
        width: 80px;
      }

      .value {
        color: #333;
        flex: 1;
      }
    }

    .order-status {
      position: absolute;
      top: 16px;
      right: 16px;
    }

    .order-actions {
      display: flex;
      justify-content: flex-end;
      margin-top: 12px;
      padding-top: 12px;
      border-top: 1px solid #eee;

      .van-button {
        min-width: 90px;
      }
    }
  }
}

.detail-content {
  padding: 20px;

  .detail-item {
    margin-bottom: 16px;
    font-size: 14px;
    display: flex;
    align-items: flex-start;

    &:last-child {
      margin-bottom: 0;
    }

    .detail-label {
      color: #666;
      width: 90px;
      flex-shrink: 0;
    }

    .detail-value {
      color: #333;
      flex: 1;
    }

    &.route-details {
      flex-direction: column;
      align-items: flex-start;

      .route-list {
        width: 100%;
        margin-top: 8px;
        max-height: 200px;
        overflow-y: auto;
        padding-right: 4px;

        .route-item {
          background-color: #f7f8fa;
          padding: 12px;
          margin-bottom: 8px;
          border-radius: 6px;
          border-left: 3px solid #1989fa;

          &:last-child {
            margin-bottom: 0;
          }

          .route-time {
            font-size: 12px;
            color: #999;
            margin-bottom: 4px;
          }

          .route-code {
            font-size: 14px;
            color: #333;
            font-weight: 500;
            margin-bottom: 4px;
          }

          .route-remark {
            font-size: 13px;
            color: #666;
            line-height: 1.5;
          }
        }
      }
    }

    &.status-remark-item {
      .detail-value {
        color: #f56c6c;
        word-break: break-all;
      }
    }
  }
}
</style> 